import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

//页面路由管理器
	import pageRouteStore from './StateMachine/pageRouteStore.js';
	
//页面信息集合
	import pageInformation from './StateMachine/pageInformation.js';
	
// seal数据及状态
import sealData from './sealData.js'
// 导航数据
import NavMenu from './NavMenu.js'
// 其他闲杂数据
import other from './other.js'

////id信息集合
//import cacheID from './StateMachine/cacheID.js'
//
////数据集
//import dynamicData from './StateMachine/dynamicData.js'

//资料页详情数据
import details from './capital/details.js'

export default new vuex.Store({
	
	modules: {
        page:pageRouteStore,
        information:pageInformation,//界面适配
        details:details,
        sealData:sealData,
        NavMenu:NavMenu,
        other:other,
//      cache_id:cacheID,
//      data_num:dynamicData
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js